module.exports = require('./lib/axios');


//////////////////
// WEBPACK FOOTER
// /var/www/24tru/releases/20230713222349/htdocs-rails/node_modules/axios/index.js
// module id = 63
// module chunks = 0 1 2 3 4 5 6 7 8 9 10